export interface SurveyQuestion {
    question_survey_id: number;
    question_survey_type: string;
    question_content: string;
    possible_answers_survey: string[];
}

export enum SurveyQuestionType {
    onePick = 'one_pick',
    openAnswer = 'open_answer',
    threeOrderedPicks = 'three_ordered_picks',
}
